import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { externalLinks } from 'src/externalLinks';
import { fetchClient, fetchClientQueryKey } from 'src/models/client/client';
import { fetchVisitPackage } from 'src/models/visit/visit';

import type { Visit } from 'src/models/visit/_types';

export const useClientSessionDrawer = (visit: Visit) => {
  const { t } = useTranslation();
  const { data: visitPackage } = useQuery({
    queryKey: ['visitPackage', visit.id],

    queryFn: () => {
      if (!visit.id) {
        return;
      }
      return fetchVisitPackage(visit.id);
    },

    enabled: !!visit.id,
  });
  const { data: client } = useQuery({
    queryKey: fetchClientQueryKey({ id: visit?.clientId || '' }),
    queryFn: () => {
      if (!visit?.clientId) {
        return;
      }
      return fetchClient({ id: visit?.clientId });
    },
    enabled: !!visit?.clientId,
  });

  const queryClient = useQueryClient();

  const updateVisitStatus = () => {
    queryClient.invalidateQueries({ queryKey: ['appointments'] });
  };

  const { user } = visit;

  // const visitWithAppointments = visit;
  // visit.appointment = appointment;

  const userManageLinks = [
    { url: externalLinks.manageClient(client?.id), label: 'Manage client' },
    {
      url: externalLinks.manageClientPayment(client?.id),
      label: 'Update credit card',
    },
    {
      url: externalLinks.manageClientPayment(client?.id),
      label: 'Update bank account',
    },
    {
      url: externalLinks.manageClientPackages(client?.id),
      label: t('Purchase package'),
    },
    {
      url: externalLinks.manageClientPayment(client?.id),
      label: 'Purchase product',
    },
    {
      url: externalLinks.manageClientDependents(client?.id),
      label: 'Manage dependents',
    },
    {
      url: externalLinks.manageClientSignatures(client?.id),
      label: 'Signatures and contracts',
    },
  ];

  const openLink = (url) => {
    window.open(url, '_blank');
  };

  return {
    visitPackage,
    client,
    updateVisitStatus,
    openLink,
    userManageLinks,
    user,
  };
};
